import { Box } from '@mui/material'
import AiAskBarEmailReplyToolbarPrimary from './AiAskBarEmailReplyToolbarPrimary'
import AiAskBarEmailReplyToolbarSecondary from './AiAskBarEmailReplyToolbarSecondary'
import styles from './index.module.scss'

export default function AiAskBarEmailReplyToolbar({ attachments, handleOpenFilePicker }) {
  return (
    <Box className={styles.emailReplyToolbar} role="group" aria-label="Reply tools">
      <AiAskBarEmailReplyToolbarPrimary attachments={attachments} handleOpenFilePicker={handleOpenFilePicker} />
      <AiAskBarEmailReplyToolbarSecondary />
    </Box>
  )
}
